import { Component, OnInit } from '@angular/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { HelperService, HTTPService } from 'app/services';
import { findIndex, trim } from 'lodash';

export interface IWarrantyEligible {
    warrantyType: string;
    partWarrantyType: string;
    warrantyNumber: string;
    isSetCostPriceZero: boolean;
    // For Tires Only
    isSetPriceZeroOnly: boolean,
    selectedPart: IParWarrantytHistory;
    itemId: string;
    serviceId: string;
    bundleId: string;
    isSkipedItem: boolean;
    disableHistory: boolean;
    replacementInvoice?: IParWarrantytHistory;
    replacementType?: string;
};

export interface IParWarrantytHistory {
    code: string;
    invoiceDate: string;
    partName: string;
    partNumber: string;
    warrantyNumber: string;
    _id: string;
    invoiceId: string;
    invoiceCode?: string;
};
@Component({
    selector: 'app-warranty-eligible-dialog',
    templateUrl: './warranty-eligible-dialog.component.html',
    styleUrls: ['./warranty-eligible-dialog.component.scss'],
    providers: [DialogService]
})
export class WarrantyEligibleDialogComponent implements OnInit {
    itemTitle: string = '';
    partNumber: string = '';
    warrantyEligible: IWarrantyEligible = {
        warrantyType: 'first-time',
        partWarrantyType: '',
        warrantyNumber: '',
        isSetCostPriceZero: false,
        // For Tires Only
        isSetPriceZeroOnly: false,
        disableHistory: false,
        selectedPart: {
            code: '',
            invoiceDate: '',
            partName: '',
            partNumber: '',
            warrantyNumber: '',
            _id: '',
            invoiceId: ''
        },
        itemId: '',
        serviceId: '',
        bundleId: '',
        isSkipedItem: false,
    };
    isWarrantyNumberAddonEnabled: boolean = false;
    isLoading: boolean = true;
    partWarrantiesHistory: IParWarrantytHistory[] = [];
    error: any = {};
    type: string = '';
    isWarrantyPartType: boolean = false;
    isMultipleItemsView: boolean = false;
    eligibleItems: any[] = [];
    currentItemId: string = '';
    currentItemIndex: number = 0;
    vehicleId: string = '';
    customerId: string = '';
    selectedWarrantyItems: any = {};
    previousManualWarranty: any = {};
    invoicedRO: boolean = false;
    zCode: string = '';
    constructor(
        private httpService: HTTPService,
        private helperService: HelperService,
        private dynamicDialogRef: DynamicDialogRef,
        private dynamicDialogConfig: DynamicDialogConfig,
    ) { }

    ngOnInit(): void {
        const { itemTitle, isWarrantyNumberAddonEnabled, itemId, partNumber, vehicleId, customerId, type,
            isMultipleItemsView, eligibleItems, warranty, invoicedRO, zCode } = this.dynamicDialogConfig.data;
        this.isWarrantyPartType = type === 'part' ? true : false;
        this.warrantyEligible.isSetCostPriceZero = type === 'part' ? true : false;
        this.warrantyEligible.isSetPriceZeroOnly = type === 'tire' ? true : false;
        this.itemTitle = itemTitle;
        this.partNumber = partNumber;
        this.currentItemId = itemId;
        this.vehicleId = vehicleId;
        this.customerId = customerId;
        this.invoicedRO = invoicedRO;
        if (zCode && zCode?.length > 0) {
            this.invoicedRO = true;
        }
        this.isWarrantyNumberAddonEnabled = isWarrantyNumberAddonEnabled;
        if (eligibleItems?.length && isMultipleItemsView) {
            this.eligibleItems = eligibleItems;
            this.isMultipleItemsView = isMultipleItemsView;
            this.currentItemIndex = 0;
            this.setItemData(this.currentItemIndex);
        }

        if (!isMultipleItemsView) {
            if (this.currentItemId && vehicleId && customerId) {
                const data: any = {
                    itemId: this.currentItemId,
                    customerId,
                    vehicleId
                }
                if (this.partNumber) {
                    data.code = this.partNumber;
                }
                this.getWarrantiesOrdersByItemId(data);
            } else {
                this.isLoading = false;
            }
        }

        if (warranty?.replacementInvoice) {
            this.warrantyEligible.partWarrantyType = warranty.replacementType;
            this.handleChange('warrantyType', warranty.type);

            this.warrantyEligible.replacementInvoice = {
                ...warranty.replacementInvoice,
                warrantyNumber: warranty.previousWarrantyNumber,
            };
        }

        if (warranty?.replacementType === 'being-replaced') {

            this.warrantyEligible.selectedPart = {
                ...warranty.replacementInvoice,
                // _id: warranty,
            };
        }
    }

    getNewWarrantyeligibleObj(): IWarrantyEligible {
        const warrantyEligible: IWarrantyEligible = {
            warrantyType: 'first-time',
            partWarrantyType: 'being-replaced',
            warrantyNumber: '',
            isSetCostPriceZero: false,
            // For Tires Only
            isSetPriceZeroOnly: false,
            disableHistory: false,
            selectedPart: {
                code: '',
                invoiceDate: '',
                partName: '',
                partNumber: '',
                warrantyNumber: '',
                _id: '',
                invoiceId: ''
            },
            itemId: '',
            serviceId: '',
            bundleId: '',
            isSkipedItem: false,
        };

        return warrantyEligible;
    }

    handleAction(actionType: string) {
        if (actionType === 'next') {
            if (!this.isValidForm()) {
                return;
            }
        }

        if (actionType === 'skip') {
            this.warrantyEligible.isSkipedItem = true;
        } else {
            this.warrantyEligible.isSkipedItem = false;
        }

        this.selectedWarrantyItems[this.currentItemIndex] = this.helperService.deepCopy(this.warrantyEligible);


        this.eligibleItems[this.currentItemIndex] = {
            ...this.eligibleItems[this.currentItemIndex],
            selectedPart: this.helperService.deepCopy(this.warrantyEligible.selectedPart),
            replacementInvoice: this.helperService.deepCopy(this.warrantyEligible.selectedPart),
            replacementType: this.warrantyEligible.partWarrantyType,
            warranty: this.warrantyEligible
        }

        if (this.currentItemIndex >= 0 && this.currentItemIndex <= (this.eligibleItems?.length - 1)) {
            if (actionType === 'next') {
                this.setItemData(this.currentItemIndex + 1);
            } else if (actionType === 'prev') {
                this.setItemData(this.currentItemIndex - 1);
            } else if (actionType === 'skip') {
                if (this.currentItemIndex === (this.eligibleItems?.length - 1)) {
                    this.handleMultipleItemConfirm();
                } else {
                    this.setItemData(this.currentItemIndex + 1);
                }

            }

        }

        if (actionType === 'confirm') {
            this.handleMultipleItemConfirm();
        }


    }

    setItemData(index: number) {
        if (this.eligibleItems?.length) {
            this.isWarrantyPartType = this.eligibleItems[index].type === 'part' ? true : false;

            this.itemTitle = this.eligibleItems[index].itemTitle;
            this.partNumber = this.eligibleItems[index].partNumber;
            this.currentItemId = this.eligibleItems[index].itemId;

            this.currentItemIndex = index;
            if (this.selectedWarrantyItems[this.currentItemIndex]) {
                this.warrantyEligible = this.helperService.deepCopy(this.selectedWarrantyItems[this.currentItemIndex]);
            } else {
                this.warrantyEligible = this.getNewWarrantyeligibleObj();
            }

            this.warrantyEligible.isSetCostPriceZero =
                this.eligibleItems[index].isSetCostPriceZero ?? this.eligibleItems[index].type === 'part';

            this.warrantyEligible.isSetPriceZeroOnly =
                this.eligibleItems[index].isSetPriceZeroOnly ?? this.eligibleItems[index].type === 'tire';

            this.warrantyEligible.itemId = this.eligibleItems[index]?.itemId || '';
            this.warrantyEligible.serviceId = this.eligibleItems[index]?.serviceId || '';
            this.warrantyEligible.bundleId = this.eligibleItems[index]?.bundleId || '';
            this.warrantyEligible.replacementInvoice = this.eligibleItems[this.currentItemIndex].selectedPart;


            const data: any = {
                itemId: this.currentItemId,
                customerId: this.customerId,
                vehicleId: this.vehicleId
            };
            if (this.partNumber) {
                data.code = this.partNumber;
            }
            this.error.warrantyNumber = '';
            this.getWarrantiesOrdersByItemId(data);
        }
    }

    getWarrantiesOrdersByItemId(data: any) {
        this.isLoading = true;
        this.httpService.getWarrantiesOrdersByItemId(data).then(
            (res: any) => {
                this.partWarrantiesHistory = res?.length ? res : [];
                this.warrantyEligible.disableHistory = !this.partWarrantiesHistory.length;

                if (this.partWarrantiesHistory.length === 1 && this.warrantyEligible.partWarrantyType !== 'manually-entered') {
                    this.selectUnSelectPart(this.partWarrantiesHistory[0]);
                    this.warrantyEligible.partWarrantyType = 'being-replaced';
                }
                else if (this.partWarrantiesHistory.length > 1 &&
                    this.warrantyEligible.partWarrantyType !== 'manually-entered'

                ) {
                    const history: any = this.partWarrantiesHistory.filter((part: any) =>
                        part.warrantyNumber === this.warrantyEligible?.replacementInvoice?.warrantyNumber &&
                        part.partNumber === this.warrantyEligible?.replacementInvoice?.partNumber &&
                        part.partName === this.warrantyEligible?.replacementInvoice?.partName
                    )[0] || this.partWarrantiesHistory[0];

                    this.selectUnSelectPart(history);
                    this.warrantyEligible.partWarrantyType = 'being-replaced';
                }
                else {
                    this.warrantyEligible.partWarrantyType = 'manually-entered';
                }

                const index = findIndex(this.eligibleItems, { itemId: this.selectedWarrantyItems.itemId });
                if (index > -1) {
                    const item = this.eligibleItems[index];
                    this.warrantyEligible = {
                        ...this.warrantyEligible,
                        partWarrantyType: item.warranty.replacementType || this.warrantyEligible?.partWarrantyType,
                        warrantyType: item.warranty.type,
                        selectedPart: item.selectedPart,
                        replacementInvoice: item.selectedPart
                    };
                }
            },
            (err: any) => {
                this.helperService.showToaster('error', err);
            }
        ).finally(() => {
            this.isLoading = false;
        })
    }

    handleClose(isSuccess: boolean = false, data: any = {}) {
        if (isSuccess && !data.warrantyType && !this.isMultipleItemsView) {
            data = {
                ...this.warrantyEligible,
                warrantyType: "not-warranty"
            }
        }
        this.dynamicDialogRef.close({ isSuccess, data });
    }

    handleMultipleItemConfirm() {
        if (this.isValidItemsList()) {
            const itemList = Object.values(this.selectedWarrantyItems);
            this.handleClose(true, itemList);
        }
    }

    handleConfirm() {
        if (this.isValidForm()) {
            this.handleClose(true, this.warrantyEligible);
        }

    }

    handleChange(key: string, event: any) {
        this.warrantyEligible[key] = event;
        if (event === 'manually-entered') {
            this.warrantyEligible.selectedPart = this.previousManualWarranty || this.getPartWarrantyHistoryEmptyObject();
        } else if (['being-replaced', 'replacement'].includes(event) && this.partWarrantiesHistory?.length) {
            this.selectUnSelectPart(this.partWarrantiesHistory[0]);
        }

        if (this.warrantyEligible?.partWarrantyType !== 'manually-entered') {
            this.error.warrantyNumber = '';
            this.warrantyEligible.warrantyNumber = '';
        }

        if (key === 'isSetPriceZeroOnly' || key === 'isSetCostPriceZero') {
            const index = findIndex(this.eligibleItems, { itemId: this.warrantyEligible.itemId });
            if (index > -1) {
                this.eligibleItems[index][key] = event;
            }
        }
    }

    isValidItemsList(): boolean {
        let isValid = true;
        const warrantyEligibleItems = Object.values(this.selectedWarrantyItems);
        if (warrantyEligibleItems?.length) {
            warrantyEligibleItems.forEach((warrantyEligible: IWarrantyEligible) => {
                if (warrantyEligible.partWarrantyType === 'manually-entered' &&
                    !warrantyEligible.isSkipedItem &&
                    warrantyEligible.warrantyType === "replacement"
                ) {

                    if (warrantyEligible.partWarrantyType === 'manually-entered') {
                        this.error = {};
                        const { partNumber, invoiceCode, invoiceDate, warrantyNumber } = warrantyEligible?.selectedPart || {};
                        if (
                            !trim(partNumber) ||
                            !trim(invoiceCode) || !trim(invoiceDate) || !trim(warrantyNumber)
                        ) {
                            isValid = false;
                            this.helperService.showToaster('error', 'Required fields missing');
                        }

                        if (!trim(invoiceCode)) {
                            this.error.invoiceCode = 'Field is required';
                        }

                        if (!trim(partNumber)) {
                            this.error.partNumber = 'Field is required';
                        }

                        if (!trim(warrantyNumber)) {
                            this.error.warrantyNumber = 'Field is required';
                        }

                        if (!trim(invoiceDate)) {
                            this.error.invoiceDate = 'Field is required';
                        }
                    }
                }

            });

        }

        return isValid;
    }

    isValidForm(): boolean {
        let isValid = true;

        if (this.warrantyEligible.partWarrantyType === 'being-replaced'
            && this.warrantyEligible.warrantyType !== 'first-time'
        ) {
            if (!this.warrantyEligible.selectedPart?._id) {
                this.error.warrantyNumber = '* Warranty number is required';
                isValid = false;
            }
        }




        if (this.warrantyEligible.partWarrantyType === 'manually-entered'
            && this.warrantyEligible.warrantyType !== 'first-time'
        ) {

            if (this.warrantyEligible.partWarrantyType === 'manually-entered') {
                this.error = {};
                const { partNumber, invoiceCode, invoiceDate, warrantyNumber } = this.warrantyEligible?.selectedPart || {};
                if (
                    !trim(partNumber) ||
                    !trim(invoiceCode) || !trim(invoiceDate) || !trim(warrantyNumber)
                ) {
                    isValid = false;
                    this.helperService.showToaster('error', 'Required fields missing');
                }

                if (!trim(invoiceCode)) {
                    this.error.invoiceCode = 'Field is required';
                }

                if (!trim(partNumber)) {
                    this.error.partNumber = 'Field is required';
                }

                if (!trim(warrantyNumber)) {
                    this.error.warrantyNumber = 'Field is required';
                }

                if (!trim(invoiceDate)) {
                    this.error.invoiceDate = 'Field is required';
                }

            }

        }

        if (!isValid && this.warrantyEligible.partWarrantyType === 'being-replaced') {
            // if (!isValid && this.warrantyEligible.warrantyType !== 'first-time') {
            this.helperService.showToaster('error', 'Warranty number is required');
        }

        return isValid;

    }

    selectUnSelectPart(part: IParWarrantytHistory) {
        this.warrantyEligible.selectedPart = this.helperService.deepCopy(part);
    }

    getPartWarrantyHistoryEmptyObject(): IParWarrantytHistory {
        return {
            code: '',
            invoiceDate: '',
            partName: '',
            partNumber: '',
            warrantyNumber: '',
            _id: '',
            invoiceId: ''
        };
    }

    handleManualWarranty(event: any) {
        this.previousManualWarranty = this.warrantyEligible.selectedPart;
        this.warrantyEligible = { ...this.warrantyEligible, ...event };
    }

}